import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";
import { countriesApi } from "@/lib/api";
import { useCurrency } from "@/lib/currency";
import { ArrowUpRight } from "lucide-react";

const Countries = () => {
  const [countries, setCountries] = useState([]);
  const { format } = useCurrency();
  useEffect(() => { countriesApi.list().then(setCountries).catch(() => {}); }, []);

  return (
    <div className="bg-surface-app min-h-screen text-ink-body">
      <MarketingNav />
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-16 pb-12">
        <div className="text-xs uppercase tracking-[0.28em] text-ink-muted font-mono-accent mb-6">
          Supported jurisdictions
        </div>
        <h1 className="h-display text-5xl md:text-7xl max-w-3xl">
          Seven markets. <span className="italic text-artha-amber">One playbook.</span>
        </h1>
        <p className="mt-6 text-lg text-ink-muted max-w-2xl">
          Each jurisdiction below is wired end-to-end — from entity creation to annual filing — with a vetted local partner on the other side.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-24 space-y-px bg-artha-light-border border border-border-subtle">
        {countries.map((c, idx) => (
          <div key={c.code} className="bg-surface-app grid grid-cols-12 gap-6 p-8 md:p-12 hover:bg-surface-card transition-colors"
               data-testid={`country-row-${c.code}`}>
            <div className="col-span-12 md:col-span-4 flex items-start gap-5">
              <div className="text-5xl">{c.flag}</div>
              <div>
                <div className="text-xs font-mono-accent uppercase tracking-[0.2em] text-ink-muted">
                  {String(idx + 1).padStart(2, "0")} · {c.code}
                </div>
                <h2 className="h-display text-3xl md:text-4xl mt-2">{c.name}</h2>
                <div className="text-sm text-ink-muted mt-2">{c.tagline}</div>
                <div className="text-xs font-mono-accent uppercase tracking-[0.18em] text-ink-muted mt-3">{c.timezone}</div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-artha-light-border border border-border-subtle">
              {c.entity_types.map((e) => (
                <div key={e.id} className="bg-surface-card p-6 flex flex-col justify-between hover:bg-surface-app transition-colors">
                  <div>
                    <div className="text-lg tracking-tight">{e.name}</div>
                    <p className="text-xs text-ink-muted mt-2 leading-relaxed">{e.description}</p>
                  </div>
                  <div className="mt-6 flex items-end justify-between">
                    <div>
                      <div className="font-mono-accent text-2xl">{format(e.price)}</div>
                      <div className="text-[10px] uppercase tracking-[0.2em] text-ink-muted font-mono-accent">~{e.timeline_days} days</div>
                    </div>
                    <Link to="/signup" data-testid={`country-${c.code}-entity-${e.id}-cta`}
                      className="inline-flex items-center gap-1 text-xs text-ink-body hover:text-artha-amber">
                      Start <ArrowUpRight size={12} />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
      <Footer />
    </div>
  );
};

export default Countries;
